import {
  FETCH_POPULARSERVICE_SUCCESS,FETCH_POPULARSERVICE_FAILURE
} from "../actionTypes";

const initialState = {
  popularservice: [],
  error: null,
  message: null,
  totalPages: 1,
  totalRecords : 0,
  currentPage: 1,
};

export const popularServiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_POPULARSERVICE_SUCCESS:
      return {
         ...state,
        popularservice: action.payload.popularservice,
        message: action.payload.message,
        totalPages:action.payload.totalPages,
        currentPage: action.payload.currentPage,
        totalRecords:action.payload.totalRecords,
     };

    case FETCH_POPULARSERVICE_FAILURE:
      return { 
        ...state,
        error: action.payload,
        message:null,
        totalPages: 1,
        totalRecords : 0,
        currentPage: 1,
    };

    default:
      return state;
  }
};
